import { RegistrationModelSerialCheckResponse } from '../../models/registration-model-serial/registration-model-serial-check-response.interface';
import { RegistrationModelSerialStatus } from '../../models/registration-model-serial/registration-model-serial-status.enum';

export const mockRegistrationModelSerialCheckResponse: RegistrationModelSerialCheckResponse =
  {
    status: RegistrationModelSerialStatus.Complete,
    required: [],
  };
